const ErrorMessages = {
    errorEnFormulario: 'Lamentablemente hemos tenido un error al procesar este formulario de contacto. Por favor intenta mas tarde nuevamente.',
    errorDeConexion: 'Lamentablemente hemos tenido un error de conexion de intenet. Por favor revise su conexion e intente nuevamente.'
}

export default ErrorMessages